/**
 * §9.4 cross-cabin RT guard for the SRP fare modal.
 *
 * Re-exports shared helpers: `getFareCabin` resolves the *theme* cabin
 * (`cabinType`) so Indigo Up Front and Economy stay interchangeable across legs.
 */
export { getFareCabin, isCrossCabinMismatch } from '@/utils/flights/cabinTabs'
